import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { environment } from 'src/environments/environment';

import { TranslationService } from 'lipp-components';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  private readonly defaultTitle: string = this.buildDefaultTitle();

  private readonly translationService = inject(TranslationService);
  private readonly titleService = inject(Title);

  updateTitle(snapshot: RouterStateSnapshot): void {
    const pageKey = this.buildTitle(snapshot);

    if (!pageKey) {
      this.titleService.setTitle(`${this.defaultTitle} | Linecker`);
      return;
    }

    const key = `Pages.${pageKey}`;
    const pageTitle: string = this.translationService.translate(key);
    const title: string = `${this.defaultTitle} | ${pageTitle}`;

    this.titleService.setTitle(title);
  }

  private buildDefaultTitle(): string {
    let title: string = 'Lipp Portal';

    if (environment.development) {
      title += ' [Dev]';
    } else if (environment.staging) {
      title += ' [Staging]';
    }

    return title;
  }
}
